
import Vue from 'vue'
import TheHeader from '@/components/TheHeader.vue'

export default Vue.extend({
  name: 'BaseLayout',

  components: { TheHeader },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },
  }
})
